// Footer accordions on phone: one open at a time. On desktop the lists always show (CSS); without JavaScript too.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-footer-toggle]');
  if (!toggle) return;
  const footer = toggle.closest('[data-footer]');
  const column = toggle.closest('[data-footer-col]');
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  footer.querySelectorAll('[data-footer-col]').forEach((col) => {
    const isTarget = col === column && open;
    col.classList.toggle('is-open', isTarget);
    col.querySelector('[data-footer-toggle]')?.setAttribute('aria-expanded', String(isTarget));
  });
});

// After a newsletter sign-up the page reloads and every sign-up form on it (footer, newsletter section) shows the same
// message. Keep it only in the form that was sent (its id is the URL's #hash; else the first) and focus it.
const messages = [...document.querySelectorAll('[data-form-message]')];
if (messages.length) {
  let sent = null;
  try {
    sent = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
  } catch {
    // Not a valid id.
  }
  const keep = messages.find((message) => sent?.contains(message)) || messages[0];
  messages.forEach((message) => {
    if (message === keep) return;
    message.closest('form')?.querySelectorAll('[aria-invalid]').forEach((input) => {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    });
    message.remove();
  });
  // After load: Chrome clears focus when it scrolls to the URL's #form (not focusable) during loading.
  const focusKept = () => setTimeout(() => keep.focus(), 0);
  if (document.readyState === 'complete') focusKept();
  else window.addEventListener('load', focusKept, { once: true });
}
